import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import type { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'
import type { Order } from 'my-purchases/types/purchaseList'

import { getMultiOrderStatus } from './getMultiOrderStatus'
import { getSingleOrderStatus } from './singleOrderStatus'

export function getStatus({
	orders,
	isActive,
	paymentMethod,
	type,
	isMulti = false,
}: {
	orders: Order[]
	isActive: boolean
	paymentMethod: PAYMENT_TYPES
	type: ORDER_TYPES
	isMulti?: boolean
}) {
	const firstOrder = orders[0]

	if (type === ORDER_TYPES.STORE) {
		return null
	}

	if (isMulti) {
		return getMultiOrderStatus({ orders, isActive, paymentMethod })
	}

	return getSingleOrderStatus({ order: firstOrder, paymentMethod, isActive })
}
